module.exports = __webpack_public_path__ + "img/Technischer_Zug.74b4acf2.svg";